import styled from 'styled-components';
import Btn020 from 'dc/Btn020';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 16px 0 16px;
`;

export const InsightsButton = styled(Btn020)`
  width: 100%;
  height: 48px;
`;
